import {Component, Input} from '@angular/core';
import {
  faExclamationCircle,
} from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-form-submitted-response-error',
  template: `
    <div *ngIf="error">
      <fa-icon [icon]="faExclamationCircle"></fa-icon>
      {{error}}
    </div>
  `,
  styles: [`
    div {
      color: #ff4f58;
      font-family: Roboto, sans-serif;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      margin: 10px 0;
    }
  `]
})

export class FormSubmittedResponseErrorComponent {
  faExclamationCircle = faExclamationCircle;
  @Input() error: string;

}



// WEBPACK FOOTER //
// ./src/app/components/atoms/form-submitted-response-error/form-submitted-response-error.component.ts